import './assets/css/text-switch.css';
import React, { useEffect, useState } from 'react';

export default function TextSwitch({
  checkedChildren,
  unCheckedChildren,
  className = '',
  checkedColourClass = 'sb-blue-bg',
  uncheckedColourClass = 'sb-blue-bg',
  defaultChecked = false,
  checked,
  onChange,
  onClick,
  style = {},
}) {
  const [localChecked, setLocalChecked] = useState(Boolean(defaultChecked));

  useEffect(() => {
    setLocalChecked(Boolean(checked));
  }, [checked]);

  const handleSwitchClick = (e) =>
    setLocalChecked((prev) => {
      if (onChange) {
        onChange(!prev, e);
      }
      if (onClick) {
        onClick(!prev, e);
      }
      return !prev;
    });

  return (
    <button
      className={'text-switch__wrapper gSemiBold fs-12 ' + className}
      onClick={handleSwitchClick}
      style={{ ...style }}
    >
      <div
        className={
          'text-switch ' +
          (localChecked
            ? 'text-switch--checked ' + checkedColourClass
            : 'text-switch--unchecked ' + uncheckedColourClass)
        }
      >
        <div className='text-switch__handle--checked'>{checkedChildren}</div>
        <div className='text-switch__handle--unchecked'>
          {unCheckedChildren}
        </div>
      </div>
      <div className='w-full overflow-hidden '>
        <div className='w-full justify-center pd-left-5 pd-right-10'>
          {unCheckedChildren}
        </div>
      </div>
      <div className='w-full overflow-hidden '>
        <div className=' w-full justify-center pd-left-10 pd-right-5'>
          {checkedChildren}
        </div>
      </div>
    </button>
  );
}
